class VariantsDrawer extends HTMLElement {
  constructor() {
    super();

    if(this.closest('shop-the-look-drawer') || this.closest('.pdp-bundle-atc-form')) {
      this.querySelectorAll(['.variants-drawer__body .shop-the-look__colour-variant']).forEach((variant) => {
        variant.addEventListener('click', this.updateColourState.bind(this));
      })
    }
  }

  connectedCallback() {
  }

  updateColourState(e) {
    const swatchColor = getComputedStyle(document.documentElement).getPropertyValue(e.currentTarget.dataset.swatchVar);
    this.querySelector('.color-swatches span.color-swatches__swatch').style.backgroundColor = `rgb(${swatchColor})`;
    if(swatchColor === '255 255 255') {
      this.querySelector('.color-swatches span.color-swatches__swatch').style.border = '1px solid #000';
    } else {
      this.querySelector('.color-swatches span.color-swatches__swatch').style.border = 'unset';
    }
    this.querySelector('.color-swatches span:last-child').innerText = e.currentTarget.querySelector('span.visually-hidden').innerText;
    this.querySelector('.color-swatches span.color-swatches__name').innerText = e.currentTarget.querySelector('span.visually-hidden').innerText;
  }

  showDrawer() {
    // set variants-drawer__body aria-hidden to false
    const drawerBody = this.querySelector('.variants-drawer__body');
    if (drawerBody) {
      drawerBody.setAttribute('aria-hidden', 'false');
    }
  }

  hideDrawer() {
    // set variants-drawer__body aria-hidden to true
    const drawerBody = this.querySelector('.variants-drawer__body');
    if (drawerBody) {
      drawerBody.setAttribute('aria-hidden', 'true');
    }

    this.dataset.view = '';
  }

  hideAllDrawerContent() {
    // get all drawer content
    const drawerContents = this.querySelectorAll('.variants-drawer__content > div[aria-hidden]');
    if (!drawerContents) {
      return;
    }

    // set aria-hidden to true
    drawerContents.forEach((drawerContent) => {
      drawerContent.setAttribute('aria-hidden', 'true');
    });

    this.classList.remove('variants-drawer--viewAll')
  }

  showDrawerContent(id) {
    // get element by id
    const drawerContent = this.querySelector(`#${id}`);
    if (!drawerContent) {
      return;
    }

    // set aria-hidden to false
    drawerContent.setAttribute('aria-hidden', 'false');
  }

  toggleViewAll(drawerElement) {
    drawerElement.classList.toggle('variants-drawer--viewAll');
  }
}

class VariantsDrawerButton extends VariantsDrawer {
  constructor() {
    super();
    this.buttons = this.parentElement.querySelectorAll('variants-drawer-button');
    this.drawerElement = this.closest('variants-drawer');
    this.imageContainer = document.querySelector('.product__media-list');
    if (!this.drawerElement) {
      return;
    }

    this.ariaControls = this.getAttribute('aria-controls');
    this.handleDrawer();
  }

  connectedCallback() {
    // add click handler event
    this.addEventListener('click', this.handleClick);
  }

  resetButtons() {
    this.buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  updateDatasetViewAttribute(view) {
    this.drawerElement.dataset.view = view;
  }

  handleClick() {
    const allDrawers = document.querySelectorAll('variants-drawer');

    allDrawers.forEach((drawer) => {
      if (drawer !== this.drawerElement) {
        drawer.hideDrawer();
        const buttons = drawer.querySelectorAll('variants-drawer-button');
        if (buttons) {
          buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        }
      }

      if (document.querySelector('body').getAttribute('data-bundle-product') === 'true') {
        this.handleImageChange(drawer);
      }
    });

    if (this.getAttribute('aria-expanded') === 'true') {
      this.drawerElement.hideDrawer();

      this.resetButtons();
      this.setAttribute('aria-expanded', 'false');
      return;
    }

    // show drawer and its content
    this.drawerElement.showDrawer();
    this.resetButtons();
    this.setAttribute('aria-expanded', 'true');

    if (!this.ariaControls) {
      return;
    }

    this.drawerElement.hideAllDrawerContent();
    this.drawerElement.showDrawerContent(this.ariaControls);
    this.updateDatasetViewAttribute(this.dataset.view);
  }

  removeWidthParameter(url) {
    return url.replace(/&width=\d+/, '');
  }
  
  createSrcset(baseImageUrl, widths) {
    return widths.map(width => `${baseImageUrl}&width=${width} ${width}w`).join(', ');
  }
  
  createNewListItem(baseImageUrl, srcset, sizes, index) {
    const newListItem = document.createElement('li');
    newListItem.classList.add('scroll-snap__item', 'product__media-item', 'product__media-item--variant');
    if (index === 0) {
      newListItem.classList.add('is-active');
    }
  
    const newImageContainer = document.createElement('div');
    newImageContainer.classList.add('product-media-container', 'media-type-image', 'media-fit-contain', 'global-media-settings', 'gradient', 'constrain-height');
  
    const imagePictureContainer = document.createElement('div');
    imagePictureContainer.classList.add('product__media', 'media', 'media--transparent');
  
    const imagePicture = document.createElement('picture');
    const imageSource = document.createElement('source');
    imageSource.setAttribute('srcset', srcset);
    imageSource.setAttribute('sizes', sizes);
    imageSource.setAttribute('media', '(min-width: 1024px)');
    imagePicture.appendChild(imageSource);
  
    const imageImg = document.createElement('img');
    imageImg.setAttribute('src', baseImageUrl);
    imagePicture.appendChild(imageImg);
  
    imagePictureContainer.appendChild(imagePicture);
    newImageContainer.appendChild(imagePictureContainer);
    newListItem.appendChild(newImageContainer);
  
    return newListItem;
  }
  
  handleVariantClick(event, newListItem, imageContainer) {
    const existingActiveItem = imageContainer.querySelector('.is-active');
    if (existingActiveItem) {
      imageContainer.replaceChild(newListItem, existingActiveItem);
    } else {
      imageContainer.prepend(newListItem);
    }
    newListItem.classList.add('is-active');
  }
  
  handleImageChange(drawer) {
    const drawerColourVariants = drawer.querySelectorAll('.shop-the-look__colour-variant');
  
    if (drawerColourVariants) {
      drawerColourVariants.forEach((drawerColourVariant, index) => {
        let colourImage = drawerColourVariant.querySelector('span').getAttribute('data-variant-image');
        
        const baseImageUrl = this.removeWidthParameter(colourImage);
        const widths = [375, 550, 750, 800, 850, 900, 1100, 1500, 1780, 2000, 3000, 3840];
        const srcset = this.createSrcset(baseImageUrl, widths);
        const sizes = "(min-width: 750px) 50vw, 100vw";
  
        const newListItem = this.createNewListItem(baseImageUrl, srcset, sizes, index);
  
        drawerColourVariant.addEventListener('click', event => this.handleVariantClick(event, newListItem, this.imageContainer));
      });
    }
  }

  handleDrawer() {
    const drawerContent = this.drawerElement.querySelector(`#${this.ariaControls}`);
    if (!drawerContent) return;

    drawerContent.addEventListener('click', event => {
      if (event.target.closest('.shop-the-look__colour-variant') || event.target.closest('.card-variant-selector')) {
        this.handleClick();
      }
    });
  }
}

class VariantsDrawerRevealButton extends VariantsDrawer {
  constructor() {
    super();
    this.swatches = this.parentElement.parentElement.querySelectorAll('product-group-swatch');
    this.minSwatchesForViewAllButton = 6;

    if (!this.swatches || this.swatches.length <= this.minSwatchesForViewAllButton) {
      return;
    }

    this.style.display = 'flex';

    this.drawerElement = this.closest('variants-drawer');
    if (!this.drawerElement) {
      return;
    }
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  handleClick() {
    this.toggleViewAll(this.drawerElement);
  }
}

window.customElements.define('variants-drawer', VariantsDrawer);
window.customElements.define('variants-drawer-button', VariantsDrawerButton);
window.customElements.define('variants-drawer-reveal-button', VariantsDrawerRevealButton);
